module.exports = __webpack_public_path__ + "img/h5img35.4ddc54ba.png";